
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prompt/[promptSlug]",
      function () {
        return require("private-next-pages/prompt/[promptSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prompt/[promptSlug]"])
      });
    }
  